import { app } from '../../../bootstrap/core';
import { chartComponent } from './chart.component';

// Import submodules
import './chartDiagram/chartDiagram';
import './chartLabel/chartLabel';

app
  .component('chart', chartComponent);
